import Vue from 'vue';
import Vuex from 'vuex';
import auth from '@/store/Auth';
import process from '@/store/Process';
import customer from '@/store/Customer';
import analytics from '@/store/Analytics';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loading: false,
    presentationMode: false,
  },
  mutations: {
    UPDATE_LOADING(state, payload) {
      state.loading = payload;
    },
    UPDATE_PRESENTATION_MODE(state, payload) {
      state.presentationMode = payload;
    },
  },
  actions: {
    toggleLoading(context, payload) {
      context.commit('UPDATE_LOADING', payload);
    },
    togglePresentationMode(context, payload) {
      context.commit('UPDATE_PRESENTATION_MODE', payload);
    },
  },
  modules: {
    auth,
    process,
    customer,
    analytics,
  },
});
